import { REST } from 'utils/rest';

const url = '/api/contact-us/';

export class ContactUs {
  static post(form, onSuccess, onError) {
    return REST.post(url, form, onSuccess, onError);
  }
}
